import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { AuthHttpService } from '../../core/services/api/auth-http.service';
import { ToasterService } from '../../core/services/visual/toaster.service';
import { LoginInterface } from './login.interface';

@Component({
  selector: 'ltg-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  constructor(
    private authService: AuthHttpService,
    private router: Router,
    private toasterService: ToasterService
  ) { }

  onLogin(login: LoginInterface) {
    this.authService.login(login.email, login.password)
      .subscribe(
        () => this.router.navigate(['/home']),
        () => this.toasterService.showErrorTranslating('auth.login.error')
      );
  }

}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/auth/login/login.component.ts